"use client";

import { LinkButton } from "@/components/atoms/link-button";
import RichTextWrapper from "@/components/atoms/RichTextWrapper";
import { useHasHydrated } from "@/hooks/useHasHydrated/useHasHydrated";
import {
  generateLinkFromGeneralLink,
  generateTargetFromLink,
  LinkType,
} from "@/lib/utils";
import { ChevronRightIcon } from "lucide-react";
import { useLocale } from "next-intl";
import React from "react";

type CancellationFeesProps = {
  cancellationFeeApplyLink: {
    type: LinkType;
    metadata: {
      url: string;
      target: string;
    };
  };
  cancellationFeeApplyText: string;
};
/**
 * CancellationFees Component
 * Renders a link button for cancellation fee information.
 * Handles locale-based link generation and ensures rendering only after hydration to avoid SSR mismatch.
 */
const CancellationFees: React.FC<CancellationFeesProps> = ({
  cancellationFeeApplyLink,
  cancellationFeeApplyText,
}) => {
  const locale = useLocale();
  const href = generateLinkFromGeneralLink(cancellationFeeApplyLink, locale);
  const target = generateTargetFromLink(cancellationFeeApplyLink);
  const hasHydrated = useHasHydrated();

  return (
    <>
      {hasHydrated && (
        <LinkButton
          href={href || "#"}
          target={target}
          variant="primary"
          hierarchy="tonal"
          className="mt-[30px] mb-[30px] flex w-fit items-center gap-1 rounded-none border-b border-gray-950 bg-transparent p-0 text-[12px] text-gray-400"
        >
          <RichTextWrapper content={cancellationFeeApplyText} />
          <ChevronRightIcon className="h-5 w-5" />
        </LinkButton>
      )}
    </>
  );
};

export default CancellationFees;
